<template>
  <div
    class="block-actions-origin"
  >
    <div
      class="block-actions"
      :class="`${blockData.type}-block`"
    >
      <div
        class="block-action-icon __edit"
        v-if="isImageBlock"
        @click="editImageBlock"
        v-tooltip="changeImageTooltip"
      >
        <font-awesome-icon icon="image" />
      </div>
      <!-- <div
        class="block-action-icon __edit"
        v-if="isImageBlock"
        @click="cropImage"
        v-tooltip="'Crop image'"
      >
        <font-awesome-icon
          icon="crop"
        />
      </div> -->
      <div
        class="block-action-icon __duplicate"
        @click="duplicateBlock"
        v-tooltip="duplicateTooltip"
      >
        <aha-icon
          name="duplicate"
          width="28"
          height="28"
          viewBox="0 0 20 20"
        />
      </div>
      <div
        class="block-action-icon __delete"
        @click="deleteBlock"
        v-tooltip="deleteTooltip"
      >
        <aha-icon
          name="delete2"
          width="28"
          height="28"
          viewBox="0 0 20 20"
        />
      </div>
      <div
        class="block-action-icon __context-menu"
        @click="openContextMenuBlock($event)"
        v-tooltip="contextMenuTooltip"
        v-if="isShowContextMenuTrigger"
      >
        <aha-icon
          name="more"
          viewBox="0 0 20 20"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    onClickDuplicateBlock: {
      type: Function,
      default: () => {},
    },
    onClickDeleteBlock: {
      type: Function,
      default: () => {},
    },
    onClickEditImageBlock: {
      type: Function,
      default: () => {},
    },
    onClickCropImageBlock: {
      type: Function,
      default: () => {},
    },
    onClickOpenContextMenuBlock: {
      type: Function,
      default: () => {},
    },
    blockData: {
      type: [Object, Array],
      default: null,
    },
  },
  computed: {
    isImageBlock() {
      return this.blockData && this.blockData.type === 'Image'
    },
    duplicateTooltip() {
      return {
        content: 'Duplicate',
        classes: 'block-action-tooltip',
      }
    },
    deleteTooltip() {
      return {
        content: 'Delete',
        classes: 'block-action-tooltip',
      }
    },
    changeImageTooltip() {
      return {
        content: 'Change image',
        classes: 'block-action-tooltip',
      }
    },
    isShowContextMenuTrigger() {
      // Disable context menu trigger when selecting multiple blocks
      if (this.blockData && Array.isArray(this.blockData)) {
        return this.blockData.length === 1
      }
      // If selecting a single block, return true
      return this.blockData !== null
    },
    contextMenuTooltip() {
      return {
        content: 'More',
        classes: 'block-action-tooltip',
      }
    },
  },

  methods: {
    duplicateBlock() {
      this.onClickDuplicateBlock()
    },
    deleteBlock() {
      this.onClickDeleteBlock()
    },
    editImageBlock() {
      this.onClickEditImageBlock()
    },
    openContextMenuBlock(event) {
      this.onClickOpenContextMenuBlock(event)
    },
  },
}
</script>

<style lang="scss" scoped>
.block-actions-origin {
  width: 1px;
  height: 1px;
  background: transparent;
  position: relative;
  cursor: default;
}
.block-actions {
  position: absolute;
  bottom: 8px;
  left: 0;
  display: flex;
  background: #fff;
  border-radius: 4px;
  border: 1px solid #ccc;
  padding-right: 0px;
  padding-left: 0px;
  filter: drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.12));
  &.Image-block {
    bottom: -54px;
    left: 10px;
  }
}

.block-action-icon {
  padding: 8px;
  transition: color 0.2s ease;
  cursor: pointer;
  &.__edit svg {
    width: 24px;
    height: 24px;
  }
  &.__duplicate, &.__edit, &.__context-menu {
    @apply text-base-100;
    &:hover {
      @apply bg-secondary-15;
    }
  }
  &.__delete {
    @apply text-base-100;
    &:not(.disabled):hover {
      @apply bg-secondary-15;
    }
  }
}
</style>
